import React , { Component } from 'react';

import LockableLink from '../LockableLink';

import Helpable from '../Helpable';

import ChartsStore from '../../store/ChartsStore';

class MainMenu extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      isLoading: false
    }
  }

  componentDidMount() {
    ChartsStore.addChangeListener(this.handleChange);
  }


  componentWillUnmount() {
    ChartsStore.removeChangeListener(this.handleChange);
  }

  handleChange() {
    this.setState({isLoading:ChartsStore.isLoading()});
  }

  render() {
    const {formatMessage} = this.props.intl;
    const {location} = this.props;
    let pathname = (location?location.pathname:'');
    let paths = pathname.split('/');
    //Prendo il primo che corrisponde alla componente, il secondo l'operazione
    let selected = paths[1] || '';

    return (
      <Helpable bind="mainMenu" guideRef="mainmenu.guide" attachment="top left">
        <nav id="mainMenu" className="nav-pf-vertical-alt">
          <ul className="list-group">
            <li className={(selected==='domain')?'active list-group-item':'list-group-item'}>
              <LockableLink to="/domain/growth" isLocked={this.state.isLoading}>
                <span className="fa fa-globe"
                  title={formatMessage({id:'tabs.domains'})}
                  data-toggle="tooltip"
                  data-placement="right" />
                <span className="list-group-item-value">
                  {formatMessage({id:'tabs.domains'})}
                </span>
              </LockableLink>
            </li>

            <li className={(selected==='registrar')?'active list-group-item':'list-group-item'}>
              <LockableLink to={{pathname:"/registrar/registration", query:{zone:'all'}}} isLocked={this.state.isLoading}>
                <span className="fa fa-building"
                  title={formatMessage({id:'tabs.registrars'})}
                  data-toggle="tooltip"
                  data-placement="right" />
                <span className="list-group-item-value">
                  {formatMessage({id:'tabs.registrars'})}
                </span>

              </LockableLink>
            </li>
            <li className={(selected==='registrant')?'active list-group-item':'list-group-item'}>
              <LockableLink to={{pathname:"/registrant/registration", query:{zone:'all'}}} isLocked={this.state.isLoading}>
                <span className="fa fa-user"
                  title={formatMessage({id:'tabs.registrants'})}
                  data-toggle="tooltip"
                  data-placement="right" />
                <span className="list-group-item-value">
                  {formatMessage({id:'tabs.registrants'})}
                </span>
              </LockableLink>
            </li>
          </ul>
        </nav>
      </Helpable>
    );
    }
}

export default MainMenu;



// WEBPACK FOOTER //
// ./src/components/Header/MainMenu.js